import styled from "styled-components";

export const BackToTop = styled.div`
	position: fixed;
	bottom: 24px;
	right: 24px;
	z-index: 5;

	width: 44px;
	height: 44px;

	border-radius: 50%;
	background: #fff;

	display: flex;
	align-items: center;
	justify-content: center;

	cursor: pointer;

	box-shadow: 0 2px 10px rgba(0, 0, 0, 0.15);

	transition:
		transform 0.15s ease,
		opacity 0.15s ease;

	&:hover {
		transform: scale(1.05);
	}

	&:active {
		transform: scale(0.95);
	}
`;
